
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
const DeleteAccount = ({ userEmail, refresh, content,width}) => {
    DeleteAccount.propTypes = {
        userEmail: PropTypes.string,
        content: PropTypes.string,
        refresh: PropTypes.func,
        height: PropTypes.any,
        width:PropTypes.any,
    };
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();
    // ! when the CORS error wfixed : in case of refresh token expired

    const deleteAccount = async (e, userEmail) => {
        e.preventDefault();
        // OK || Cancel QUestion ???
        try {
            console.log('User EMail selected ' + userEmail);
            // TODO: no response from Backend
            const response = await axiosPrivate.delete(`/users/deleteUser/${userEmail}`, {
                // TODO: I deleted this input  ... since the AT is enough
                userEmail
            });
            console.log(response.data);
            Swal.fire({
                text: i18n.t(response.data.message)
            });
            if(typeof refresh == 'function')
                refresh();
            // location.reload()
        } catch (error) {
            console.log(error.response?.status);
            Swal.fire({
                text: i18n.t(error.response?.data.error)
            });
            //?  if is mounted==true do next [setUsers..]

            // console.log("Navigate to login again ,,,");
            // send user / backoffice to login,
            // and then navigate him to same page/route that he came from using browser history
            // false && navigate('/login', { state: { from: location }, replace: true })
        }
    };

    return (
        <>
            <Button
                variant="text"
                onClick={(e) => {
                    Swal.fire({
                        html: '<p>Êtes-vous sûr de vouloir supprimer ce compte?</p>',//+`${facture?.Statut}`,
                        confirmButtonColor: '#5CC889',
                        cancelButtonColor: '#88898f',
                        cancelButtonText: i18n.t('Annuler'),
                        confirmButtonText: 'Oui',
                        showCancelButton: true,
                        customClass: {
                            cancelButton: 'my-cancel-button-class'
                        },
                        //confirmButtonText: 'Prestation complémentaire',
                        //cancelButtonText: 'Prestation normale',
                        // showCloseButton: true
                    }).then((result) => {
                        console.log(result);
                        if (result.isConfirmed) {
                            deleteAccount(e, userEmail);
                        }
                        if (result.isDismissed) {
                            // handleClose();
                        }
                    });
                }}
                style={{...buttonStyles(),...{color:'#EC5B56',width:width||'auto'}}} //width:'196px'
                // className="danger"
                endIcon={<DeleteForeverOutlinedIcon style={{color:'#EC5B56'}}/>}
            >
                {content}
            </Button>
        </>
    );
};

export default DeleteAccount;
